// extracted by mini-css-extract-plugin
module.exports = {"hotspotProductCardWraper":"Hotspot_hotspotProductCardWraper__2jrlV"};